import { PaymentMethod } from "./paymentMethod";

export const Subscription = {
    Standard: "STANDARD",
    Lite: "LITE"
} as const;
export type Subscription = typeof Subscription[keyof typeof Subscription];
/**
 * NOTE: PaymentPlanには以下のような命名規則がある:
 * {subscription}_{duration}_{paymentMethod}_{amount}
 * 内訳
 * subscription: 上記のSubscriptionのenum
 * duration: 月=M、週=W、日=D
 * paymentMethod: IOS_IAPかCARDか
 * amount: 金額
 */
export const PaymentPlan = {
    Standard1MCard9800: "STANDARD_1M_CARD_9800",
    Standard1MIosIap12000: "STANDARD_1M_IOS_IAP_12000",
    Lite1MCard1000: "LITE_1M_CARD_1000",
    Lite1MIosIap1000: "LITE_1M_IOS_IAP_1000"
} as const;
export type PaymentPlan = typeof PaymentPlan[keyof typeof PaymentPlan];

// TODO: https://github.com/mationinc/smakon-emb/issues/3924
export const PAYMENT_PLANS: {
    id: PaymentPlan;
    subscription: Subscription;
    paymentMethod: PaymentMethod;
    amount: number;
    title: string;
    message: {
        title: string;
        description: string;
    };
}[] = [
    {
        id: PaymentPlan.Standard1MCard9800,
        subscription: Subscription.Standard,
        amount: 9800,
        paymentMethod: PaymentMethod.CREDIT_CARD,
        title: "スタンダードプラン",
        message: {
            title:
                "コンシェルジュのフルサポートと3万人の結婚相談所会員と出会える",
            description: "＼月額ずっと9,800円！／\n本気の出会いを掴みたい方必見"
        }
    },
    {
        id: PaymentPlan.Standard1MIosIap12000,
        subscription: Subscription.Standard,
        amount: 12000,
        paymentMethod: PaymentMethod.IOS_IAP,
        title: "スタンダードプラン",
        message: {
            title:
                "コンシェルジュのフルサポートと3万人の結婚相談所会員と出会える",
            description:
                "＼月額ずっと12,000円！／\n本気の出会いを掴みたい方必見"
        }
    },
    {
        id: PaymentPlan.Lite1MCard1000,
        subscription: Subscription.Lite,
        amount: 1000,
        paymentMethod: PaymentMethod.CREDIT_CARD,
        title: "ライトプラン",
        message: {
            title: "パートナーエージェントApp会員と出会える",
            description: "＼月額ずっと1,000円／"
        }
    },
    {
        id: PaymentPlan.Lite1MIosIap1000,
        subscription: Subscription.Lite,
        amount: 1000,
        paymentMethod: PaymentMethod.IOS_IAP,
        title: "ライトプラン",
        message: {
            title: "パートナーエージェントApp会員と出会える",
            description: "＼月額ずっと1,000円／"
        }
    }
];

export const LitePlanList = PAYMENT_PLANS.filter(
    plan => plan.subscription === Subscription.Lite
).map(plan => plan.id);
export const StandardPlanList = PAYMENT_PLANS.filter(
    plan => plan.subscription === Subscription.Standard
).map(plan => plan.id);
